import React, { useEffect, useState } from 'react';
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaPaperPlane } from 'react-icons/fa';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    phone: '',
    // nearestOffice: '',
 
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [showDialog, setShowDialog] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (showDialog) {
      const timer = setTimeout(() => {
        setShowDialog(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showDialog]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch('https://charethribs.com/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (res.ok) {
        setSuccess('Message sent successfully!');
        setShowDialog(true);
        setFormData({
          name: '',
          email: '',
          subject: '',
          phone: '',
          // nearestOffice: '',
        
          message: '',
        });
      } else {
        setSuccess(result.error || 'Submission failed');
      }
    } catch (error) {
      setSuccess('Server error. Try again later.');
    }

    setLoading(false);
    setTimeout(() => setShowDialog(false), 3000);
  };

  return (
    <div className="bg-white ">
      {/* Header */}
      <section className="text-center mt-5 mb-12">
        <h2 className="text-5xl font-bold text-[#b7b7a1]">Contact Us</h2>
        <p className="text-lg text-gray-600 mt-4 max-w-2xl mx-auto">
          Reliable and expert land & building documentation services.
        </p>
      </section>

      <div className="bg-[#F4F5EF]">
        <div className="max-w-7xl py-12 mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Left Info (unchanged) */}
          <div className="space-y-6">
          <h2 className="text-4xl font-bold text-[#032879]">
            Let’s <span className="text-[#b7b7a1]">Collaborate</span>  
          </h2>
          <p className="text-gray-600 text-sm">
            CHARETHRI BUSINESS SOLUTIONS LLP is your trusted partner for all documentation and liaison needs in real estate. Connect with us to make the process seamless and compliant.
          </p>

      {/* Office Info */}
<div className="flex flex-col md:flex-row md:space-x-8 space-y-6 md:space-y-0 text-sm text-gray-700">
  
  {/* Head Office */}
  <div className="flex-1 space-y-3">
    <div className="flex items-start gap-2">
      <FaMapMarkerAlt className="text-[#AF7D23] mt-1" size={23} />
      <div>
        <p className="font-semibold text-[#032879]">Head Office:</p>
        <p>No: 4, BDA Complex, Koramangala 4th Block, Bangalore – 560034</p>
      </div>
    </div>
    <div className="flex items-start gap-2">
      <FaEnvelope className="text-[#AF7D23] mt-1" />
      <div>
        <p className="font-semibold">Emails:</p>
        <p>info@charethribs.com</p>
        <p>contact@charethribs.com</p>
      </div>
    </div>
    <div className="flex items-start gap-2">
      <FaPhoneAlt className="text-[#AF7D23] mt-1" />
      <div>
        <p className="font-semibold">Contacts:</p>
        <p>+91 9832444111</p>
        <p> 080 49796720</p>
      </div>
    </div>
  </div>

  {/* Branch Office */}
  <div className="flex-1 space-y-3">
    <div className="flex items-start gap-2">
      <FaMapMarkerAlt className="text-[#AF7D23] mt-1"  size={36}/>
      <div>
        <p className="font-semibold text-[#032879]">Branch Office:</p>
        <p>Shop No: 16/A & B, No: 30, Basement, Sub-Registrar Office Building, K R Puram, Old Madras Road, Bangalore – 560036</p>
      </div>
    </div>
    <div className="flex items-start gap-2">
      <FaEnvelope className="text-[#AF7D23] mt-1" />
      <div>
        <p className="font-semibold">Emails:</p>
        <p>info@charethribs.com</p>
        <p>contact@charethribs.com</p>
      </div>
    </div>
    <div className="flex items-start gap-2">
      <FaPhoneAlt className="text-[#AF7D23] mt-1" />
      <div>
        <p className="font-semibold">Contacts:</p>
        <p>+91 9902832233</p>
        <p>+91 8618784279</p>

        {/* <p> 080 49796720</p> */}
      </div>
    </div>
  </div>
</div>

        </div>

          {/* Right Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="Your Name *"
                className="border border-gray-300 p-4 rounded-lg text-sm outline-none"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email *"
                className="border border-gray-300 p-4 rounded-lg text-sm outline-none"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="subject"
                placeholder="Subject"
                className="border border-gray-300 p-4 rounded-lg text-sm outline-none"
                value={formData.subject}
                onChange={handleChange}
              />
              <input
                type="tel"
                name="phone"
                placeholder="Your Phone *"
                className="border border-gray-300 p-4 rounded-lg text-sm outline-none"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              {/* New Nearest Office Dropdown
              <select
                name="nearestOffice"
                value={formData.nearestOffice}
                onChange={handleChange}
                className="w-full border px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#b7b7a1] md:col-span-2"
                required
              >
                <option value="">Select nearest office</option>
                <option value="Head Office - KORMANGALA">Head Office - KORMANGALA</option>
                <option value="Branch Office - K R Puram">Branch Office - K R Puram</option>
              </select> */}
              {/* New Appointment Purpose Textarea */}
            
            </div>

            <textarea
              name="message"
              rows="5"
              placeholder="Your Message *"
              className="w-full border border-gray-300 p-4 rounded-lg text-sm outline-none"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>

            {success && (
              <p className={`text-sm ${success.includes('successfully') ? 'text-green-600' : 'text-red-600'}`}>
                {success}
              </p>
            )}

            <button
              type="submit"
              className="bg-[#032879] text-white px-6 py-3 rounded-lg flex items-center gap-2 text-sm hover:bg-blue-700 transition"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Submit Now'} <FaPaperPlane className="text-xs" />
            </button>
          </form>
        </div>

        {/* Map */}
        {/* (unchanged map section here) */}
      </div>

      {/* Dialog */}
      {showDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex justify-center items-center">
          <div className="bg-white rounded-xl shadow-xl p-8 w-[90%] max-w-sm text-center">
            <h2 className="text-2xl font-bold text-[#032879] mb-2">Thank You!</h2>
            <p className="text-gray-700 text-sm">We will connect with you soon.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
